import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosSharedModule } from '../shared/module'
import { IcosButtonsModule } from '../button/module'
import { IcosDropdownItem } from './dropdown.item'
import { IcosDropdown } from './dropdown'

@NgModule({
  declarations: [IcosDropdown, IcosDropdownItem],
  exports: [IcosDropdown, IcosDropdownItem],
  imports: [CommonModule, IcosButtonsModule, IcosSharedModule],
  entryComponents: [IcosDropdown],
})
export class IcosDropdownModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosDropdownModule, providers: [] }
  }
}
